import React from "react";
import { Card } from "react-bootstrap";
import { FiMapPin, FiUsers, FiCalendar } from "react-icons/fi";

export default function ActiveJobOpenings() {
  const data = [
    ["JOB-001","Jan 03, 2026","Frontend Developer","Remote","Engineering","1452","High"],
    ["JOB-002","Jan 02, 2026","Product Manager","Office","Product","1342","High"],
    ["JOB-003","Jan 02, 2026","UX Designer","Hybrid","Design","1287","High"],
    ["JOB-004","Jan 01, 2026","Sales Executive","Office","Sales","1198","Medium"],
    ["JOB-005","Jan 01, 2026","DevOps Engineer","Office","Engineering","1134","Medium"],
  ];

  return (
    <Card className="ajo-card border-0 h-100">
      
      {/* HEADER */}
      <div className="card-header-custom">
        <h5>Active Job Openings</h5>
        <button className=" btn btn  border">View All</button>
      </div>

      {/* TABLE */}
      <div className="table-wrap">
        <table className="ajo-table">
          <thead>
            <tr>
              <th>Job ID</th>
              <th>Date</th>
              <th>Job Title</th>
              <th>Location</th>
              <th>Department</th>
              <th>Applicants</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, i) => (
              <tr key={i}>
                <td className="job-id">{item[0]}</td>

                <td className="date">
                  <FiCalendar size={14} /> {item[1]}
                </td>

                <td>
                  <div className="title">{item[2]}</div>
                  <span className={`badge ${item[6]}`}>
                    {item[6]} Priority
                  </span>
                </td>

                <td className="icon-text">
                  <FiMapPin size={14} /> {item[3]}
                </td>

                <td className="dept">{item[4]}</td>

                <td className="icon-text applicants">
                  <FiUsers size={14} /> {item[5]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* STYLES */}
      <style>{`

        .ajo-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          overflow: hidden;
          background: #fff;
        }
           .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

     
        .view-btn {
          background: #fff;
          border: 1px solid #d1d5db;
          padding: 3px 12px;
          border-radius: 6px;
          font-size: 12px;
          color: #111827;
          transition: 0.2s;
        }

        .view-btn:hover {
          background: #f9fafb;
        }

        /* TABLE */
        .ajo-table {
          width: 100%;
          border-collapse: collapse;
        }

        .ajo-table thead {
          background: #f9fafb;
        }

        .ajo-table th {
          text-align: left;
          padding: 9px 18px;
          font-size: 13px;
          font-weight: 500;
          color: #6b7280;
        }

        .ajo-table td {
          padding: 10px 18px;
          border-top: 1px solid #f1f5f9;
          font-size: 13px;
          color: #111827;
          vertical-align: middle;
        }

        .job-id {
          color: #6b7280;
          font-weight: 500;
        }

        .date {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #374151;
        }

        .icon-text {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #374151;
        }

        .dept {
          color: #6b7280;
        }

        .applicants {
          font-weight: 500;
        }

        /* TITLE */
        .title {
          font-weight: 500;
          margin-bottom: 4px;
        }

        /* BADGES */
        .badge {
          font-size: 11px;
          padding: 4px 8px;
          border-radius: 6px;
          font-weight: 500;
        }

        .badge.High {
          background: #fee2e2;
          color: #dc2626;
        }

        .badge.Medium {
          background: #dbeafe;
          color: #2563eb;
        }

        /* ROW HOVER (optional like modern UI) */
        .ajo-table tbody tr:hover {
          background: #fafafa;
        }

        /* MOBILE */
        @media (max-width: 768px) {

          .ajo-table thead {
            display: none;
          }

          .ajo-table tr {
            display: block;
            border: 1px solid #eee;
            border-radius: 8px;
            margin-bottom: 10px;
            padding: 10px;
          }

          .ajo-table td {
            display: flex;
            justify-content: space-between;
            padding: 8px 0;
            border: none;
          }

          .ajo-table td::before {
            content: attr(data-label);
            font-weight: 600;
            color: #6b7280;
          }
        }

      `}</style>
    </Card>
  );
}